"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchJSON = void 0;
/** Util to abstract away some boilerplate, and make parent functions easier to test (by mocking this fn!) */
const fetchJSON = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(url);
    if (!res.ok) {
        const json = yield res.json();
        throw json;
    }
    const data = yield res.json();
    return data;
});
exports.fetchJSON = fetchJSON;
